import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ApiAccessTokenDemoData } from '../../../data/ApiAccessTokenDemo';
import { useTemplate } from '../../features/template/TemplateProvider';
import { ApiDeleteAccessToken, ApiGetAccessTokenList } from './operation/ApiAccessTokenOperation';

const ApiAccessTokenContext = createContext();

export const useApiAccessToken = () => useContext(ApiAccessTokenContext);

function ApiAccessTokenProvider({ children }) {
    const { setMessage, setConfirm, setTemplateLoading } = useTemplate();
    const [reloadToken, setReloadToken] = useState(0);
    const [accessTokenData, setAccessTokenData] = useState({
        tokenList: ApiAccessTokenDemoData
    });

    useEffect(() => {
        setAccessTokenData({ tokenList: ApiAccessTokenDemoData });
        ApiGetAccessTokenList()
            .then(({ data }) => {
                console.log(data);
                setAccessTokenData(data);
            })
            .catch((err) => {
                setAccessTokenData([]);
                setMessage({ type: 'error', message: err.message });
            });
    }, [setMessage, reloadToken]);

    const value = useMemo(() => {
        const handleReload = () => {
            setReloadToken((prev) => prev + 1);
        };
        const handleDeleteToken = (ev, data) => {
            ev.stopPropagation();
            setConfirm({
                text: `Are you sure you want to delete this token? This action cannot be undone.`,
                textAction: 'Yes, Delete',
                clickAction: () => {
                    setTemplateLoading(true);
                    ApiDeleteAccessToken(data?.id)
                        .then(({ title }) => {
                            setMessage({ type: 'success', text: title });
                            handleReload();
                            setConfirm(null);
                            setTemplateLoading(false);
                        })
                        .catch((error) => {
                            setTemplateLoading(false);
                            setMessage({ type: 'error', text: error.message });
                        });
                }
            });
        };
        return {
            reloadToken,
            handleReload,
            accessTokenData,
            handleDeleteToken
        };
    }, [reloadToken, accessTokenData, setConfirm, setTemplateLoading, setMessage]);
    return (
        <ApiAccessTokenContext.Provider value={value}>{children}</ApiAccessTokenContext.Provider>
    );
}

export default ApiAccessTokenProvider;
